<template>
  <div class="container">
    <m-header></m-header>
    <div class="content-box">
      <div class="menu-box">
        <m-menu ref="menu" @showChildren="showChildren" @hidePopover="hidePopover"></m-menu>
        <m-menu-popover ref="popoverMenu" :menu="menu" v-show="popoverShow" @setMenuActive="setMenuActive"></m-menu-popover>
      </div>
      <div class="content">
        <div class="main">
          <nav-list></nav-list>
          <!--<keep-alive exclude='index'>-->
            <router-view />
          <!--</keep-alive>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import header from '@/components/business/header';
import menu from '@/components/business/menu';
import menuPopover from '@/components/business/menuPopover';
import navList from '../components/business/navList';

export default {
  components: {
    mHeader: header,
    mMenu: menu,
    mMenuPopover: menuPopover,
    navList
  },
  data() {
    return {
      popoverShow: false,
      menu: {}
    }
  },
  created() {
    // 设置分页条数
    this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 10);
    this.refontSize();
  },
  methods: {
    setMenuActive(menu) {
      this.$refs.menu.activeId = menu.id;
      this.$refs.menu.level1Id = menu.id;
    },
    hidePopover() {
      this.popoverShow = false;
    },
    showChildren(menu) {
      console.log(menu)
      this.menu = menu;
      this.popoverShow = true;
      this.$nextTick(() => {
        this.$refs.popoverMenu.setPopoverTop();
      });
    },
    refontSize() {
      document.documentElement.style.fontSize =
        (document.documentElement.clientWidth / 1920) * 10 + 'px';
    }
  }
};
</script>
<style>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.container .menu-box{
  overflow-y:auto;
}
.container .content-box {
  /*height: calc(100vh - 60px);*/
  height: 100%;
  display: flex;
  overflow: auto;
  flex:1;
}
.container .content-box .content {
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow-x: auto;
  width: calc(100vw - 220px);
}
.container .content-box .content .main {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/* 左侧导航栏样式优化 */
.container .content-box .menu {
  width: 106px;
}
.container .content-box .menu .menu-item {
  height: 50px;

  font-size: 1.4rem;
  line-height: 50px;
}
.container .content-box .menu .menu-item .single-item .icon-box { }
</style>



// WEBPACK FOOTER //
// src/page/Index.vue